/*
 * fn: getColorId
 *
 * Takes any amount of colorIds or arrays of colors and returns the colorId of combining them all together
 *
 * Used to find the colorId of things like paired partners or DFCs
 *
 */
import { COLOR_ID_COLORLESS, COLOR_ID_LABELS, COLOR_IDS, type ColorIdType, isColorIdType } from '@/defs/mtg'

const COLOR_ORDER = ['w', 'u', 'b', 'r', 'g']
const VALID_COLORS = new Set(COLOR_ORDER)

const getKey = (colors: Set<string>) => COLOR_ORDER.filter((c) => colors.has(c)).join('')

const COLOR_ID_BY_KEY = new Map<string, ColorIdType>(
  COLOR_IDS.map((ci) => [getKey(new Set<string>(COLOR_ID_LABELS[ci].colors)), ci]),
)

export const getColorId = (...props: (string[] | string | undefined)[]) => {
  const colors = new Set<string>()
  const addColor = (color: string) => {
    const value = color.toLowerCase()
    if (VALID_COLORS.has(value)) colors.add(value)
  }

  props.forEach((prop) => {
    if (Array.isArray(prop)) {
      prop.forEach((c) => {
        if (isColorIdType(c)) COLOR_ID_LABELS[c].colors.forEach(addColor)
        else addColor(c)
      })
    } else if (typeof prop === 'string' && isColorIdType(prop)) {
      COLOR_ID_LABELS[prop].colors.forEach(addColor)
    }
  })

  return COLOR_ID_BY_KEY.get(getKey(colors)) || COLOR_ID_COLORLESS
}
